
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","data-name":"Layer 1","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 22a1 1 0 01-.692-.278l-7.121-6.828a4.009 4.009 0 01-.015-5.672l7.131-6.939a.999.999 0 111.394 1.434l-7.121 6.929a2 2 0 00.01 2.819l7.106 6.813A1 1 0 019 22zm6.698-.284l7.112-6.94a4.01 4.01 0 00-.014-5.671l-7.103-6.826a1 1 0 00-1.386 1.442l7.089 6.811c.779.78.779 2.049.009 2.82l-7.104 6.932a1 1 0 101.396 1.432z"}})])
          )
        }
      }
    